import { BrandMark } from '../../components/brand/BrandMark';
import type { LandingContent } from './content';

/* Section anchors for the "Platform" column; the other columns are placeholders until those pages exist. */
const PLATFORM_LINKS = ['#features', '#live', '#industries', '#roi'];

export function Footer({ c }: { c: LandingContent }) {
  return (
    <footer className="lp-footer">
      <div className="lp-container">
        <div className="lp-footer-grid">
          <div>
            <a className="brand" href="#top">
              <BrandMark size={36} />
              <span>RFleet</span>
            </a>
            <p className="desc">{c.footer.desc}</p>
            <div style={{ marginTop: 18 }}>
              <span className="status">
                <i />
                <span>{c.footer.status}</span>
              </span>
            </div>
          </div>
          {c.footer.cols.map((col, ci) => (
            <div key={col.t}>
              <h4>{col.t}</h4>
              <ul>
                {col.l.map((l, li) => (
                  <li key={l}>
                    <a href={ci === 0 ? (PLATFORM_LINKS[li] ?? '#top') : '#contact'}>{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="lp-footer-bottom">
          <span>{c.footer.copy}</span>
          <span>{c.footer.made}</span>
        </div>
      </div>
    </footer>
  );
}
